'use strict';
var I18N_ERROR_AVAILABILITY, I18N_ERROR_BAD_LOCATION, I18N_ERROR_BAD_LOCATION_ENTRY, I18N_ERROR_GENERIC, LocationError, getTranslations, moveAutocomplete, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

I18N_ERROR_GENERIC = 'generic';

I18N_ERROR_BAD_LOCATION = 'bad_location';

I18N_ERROR_BAD_LOCATION_ENTRY = 'bad_location_entry';

I18N_ERROR_AVAILABILITY = 'availability';

ref = require('../helper/m_typeahead_helper'), getTranslations = ref.getTranslations, moveAutocomplete = ref.moveAutocomplete;

module.exports = LocationError = (function() {
  function LocationError(opts) {
    this.removeError = bind(this.removeError, this);
    this.displayError = bind(this.displayError, this);
    this.$form = opts.$form, this.env = opts.env, this.$resultList = opts.$resultList, this.expUX = opts.enableBetterUx;
    this.hasError = false;
    this.classes = this.expUX ? 'ls-error' : 'ls-error ls-error-old ';
    this.$locationWrapper = this.$form.find('.location-search, .ls-location-wrap');
  }

  LocationError.prototype.errorTemplate = function(query, message) {
    query = _.escape(query);
    message = _.escape(message);
    return "<ul role='list'><li data-bhw='SearchBarError' class='ls-error-dialog icon-circle-alert'>\n  <span data-bhc='location-not-found:" + query + "'>" + message + "</span>\n</li></ul>";
  };

  LocationError.prototype.displayError = function(message, query) {
    var $errorDialog, event;
    message || (message = this.translateError(I18N_ERROR_GENERIC));
    $errorDialog = $(this.errorTemplate(query, message));
    moveAutocomplete(this.$resultList, 'location', this.env);
    this.$locationWrapper.addClass(this.classes);
    this.$resultList.html($errorDialog).show();
    this.$locationWrapper.find('input').one('input.locationError', this.removeError);
    this.hasError = true;
    switch (this.env) {
      case 'desktop':
        event = 'mousedown';
        break;
      case 'mobile':
        event = 'touchend';
    }
    return $(window).one(event, this.removeError);
  };

  LocationError.prototype.removeError = function() {
    if (this.hasError) {
      this.$resultList.hide().find('.ls-error-dialog').remove();
      this.$locationWrapper.removeClass(this.classes);
      this.hasError = false;
    }
  };

  LocationError.prototype.displayBadLocationError = function(query) {
    var message, txtKey;
    if (this.expUX) {
      txtKey = I18N_ERROR_BAD_LOCATION_ENTRY;
    } else {
      txtKey = I18N_ERROR_BAD_LOCATION;
    }
    message = this.translateError(txtKey);
    return this.displayError(message, query);
  };

  LocationError.prototype.displayAvailabilityError = function(query) {
    var message;
    message = this.translateError(I18N_ERROR_AVAILABILITY);
    return this.displayError(message, query);
  };

  LocationError.prototype.translateError = function(key) {
    return getTranslations('error')[key];
  };

  return LocationError;

})();

